module.exports={
  "Published": "Udgivet",
  "on": "pÃ¥",
  "on the %s. %s %s": "den %s. %s %s",
  "Visit %s": "BesÃ¸g %s"
}
